import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Enhanced PWA Registration and Update Logic
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Leverage Vite's BASE_URL to prevent 404s on subpaths
    const swUrl = `${import.meta.env.BASE_URL}sw.js`;
    const swScope = import.meta.env.BASE_URL;

    navigator.serviceWorker.register(swUrl, { scope: swScope }).then(registration => {
      console.log('SW registered with scope: ', registration.scope);
      
      // Immediate update check
      registration.update();

      // Check for updates every 2 minutes for faster propagation
      setInterval(() => {
        registration.update();
      }, 1000 * 120);

      // Check for updates on visibility change
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update();
        }
      });

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New update found! Forcing reload...');
              installingWorker.postMessage('SKIP_WAITING');
            }
          }
        };
      };
    }).catch(registrationError => {
      console.error('SW registration failed: ', registrationError);
    });
  });

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);